import { BooleanField, Datagrid, List, TextField } from "react-admin";

function ProjectList(props) {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
        <BooleanField source="favorite" addLabel />
      </Datagrid>
    </List>
  );
}

export default ProjectList;
